<template>
  <div>

    <main-banner/>

    <template-list/>

  </div>
</template>
<script>
import TemplateList from "../components/TemplateList2";
import {mapGetters} from "vuex";
import MainBanner from '@/components/MainBanner'
import axios from "axios";

export default {
  components:{
    MainBanner,
    TemplateList
  },
  computed:mapGetters({
    login: 'login', // 로그인 상태
    shopid: 'shopid', // 로그인 상태
  }),
  data: () => ({
    demos: [],
  }),
  mounted() {
    this.$store.commit('nav_name','시작하기')
    this.$store.commit('page_name','')
    this.demo()
  },
  methods:{
    preview:function (item) {
      window.open(item.previewUrl)
    },
    addDemo:function(item){

      if(this.login!=1) {
        this.$eventBus.$emit('login_confirm')
        return
      }

      const axiosData = {
        demoId: item.demoId
      };

      this.$http
          .post('/api_home/page/demo', axiosData)
          .then(obj=>{
            if(obj.data.success == 1){
              this.$eventBus.$emit('info', '마이샵 홈 만들기','다음 목록에서 추가된 페이지를 편집해주세요.')
              this.$router.push({path:'/pages'})
              return
            }

            throw 'err'
          })
          .catch(err=>{
            this.$eventBus.$emit('error', '마이샵 홈 만들기','마이샵 홈 만들기에 실패했습니다.')
          })
    },
    demo:function () {
      this.$http
          .get('/api_home/demos')
          .then(obj=>{
            this.demos = obj.data.demoList;
          })
          .catch(err=>{console.log(err.response.data)})
    },
  }
}
</script>